<script>
export default {
    data: () =>  ({
        people: [
            {
                name: 'José Edwin García',
                role: 'Miembro Fundador | Presidente | Pachamama OBC',
                imageUrl:
                'assets/images/pachamamaobc_president_edwin_garcia.jpg',
            },
            {
                name: 'Domingo Abrego',
                role: 'Secretario/Tesorero | Pachamama OBC',
                imageUrl:
                'assets/images/pachamamaobc_domingo_abrego.png',
            },
            {
                name: 'Juan Carlos Brown',
                role: 'Vocal | Pachamama OBC',
                imageUrl:
                'assets/images/pachamamaobc_juan_carlos_brown.jpg',
            },
            {
                name: 'Luz Usme',
                role: 'Voluntaria | Pachamama OBC',
                imageUrl:
                'assets/images/pachamamaobc_luz_usme.png',
            },
            ]
        }
    )
}
</script>


<template>
    <div class="bg-white py-24 sm:py-32">
        <div class="mx-auto grid max-w-7xl gap-20 px-6 lg:px-8 xl:grid-cols-3">
            <div class="max-w-xl">
                <h2 class="text-3xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl">Conoce nuestros asociados</h2>
                <p class="mt-6 text-lg/8 text-gray-600">Somos un grupo dinámico de individuos. 
                    Quienes son apasionados por la naturaleza y sus ecosistemas.</p>
            </div>
            <ul role="list" class="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2">
                <li v-for="person in people" :key="person.name">
                    <div class="flex items-center gap-x-6">
                        <img class="size-16 rounded-full" :src="person.imageUrl" alt="" />
                        <div>
                            <h3 class="text-base/7 font-semibold tracking-tight text-gray-900">{{ person.name }}</h3>
                            <p class="text-sm/6 font-semibold text-indigo-600">{{ person.role }}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>